/*
 * Decléor — Cart upsell slider arrows (mobile).
 * ---------------------------------------------------------------------------
 * Scrolls the centered upsell slider with the prev/next arrows, LOOPING at each end
 * (next at the end → back to the first card; prev at the start → jump to the last).
 *
 * Uses EVENT DELEGATION on document so a click works no matter when the track is (re)rendered:
 * the cart drawer re-renders via the Section Rendering API on open / cart change, replacing the
 * track node — per-node binding would miss the fresh node, delegation never does. No-ops elsewhere.
 */
(function () {
  'use strict';

  function stepWidth(track) {
    var card = track.querySelector('.cart-upsell__card');
    // One card per view now (full-width rows), so the step is the card width — no inter-card gap to add.
    return card ? card.getBoundingClientRect().width : track.clientWidth;
  }

  // Scoped to .cart-upsell, not .cart-upsell__viewport: the arrows moved OUT of the viewport and into
  // the .cart-upsell__head, so that they can't sit on top of a card's "Ajouter" button.
  function trackFor(btn) {
    var root = btn.closest('.cart-upsell');
    return root ? root.querySelector('[data-upsell-track]') : null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('[data-upsell-prev],[data-upsell-next]') : null;
    if (!btn) { return; }
    var track = trackFor(btn);
    if (!track) { return; }
    e.preventDefault();

    var max = track.scrollWidth - track.clientWidth - 2;
    if (btn.hasAttribute('data-upsell-next')) {
      if (track.scrollLeft >= max) {
        track.scrollTo({ left: 0, behavior: 'smooth' });            // loop → first card
      } else {
        track.scrollBy({ left: stepWidth(track), behavior: 'smooth' });
      }
    } else {
      if (track.scrollLeft <= 2) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });  // loop → last card
      } else {
        track.scrollBy({ left: -stepWidth(track), behavior: 'smooth' });
      }
    }
  });
})();
